import match from 'autosuggest-highlight/match/index';
import parse from 'autosuggest-highlight/parse/index';
import { Paper, withStyles } from 'material-ui';
import HotelIcon from 'material-ui-icons/Hotel';
import CityIcon from 'material-ui-icons/LocationCity';
import LocationIcon from 'material-ui-icons/LocationOn';
import { MenuItem } from 'material-ui/Menu/index';
import TextField from 'material-ui/TextField/TextField';
import React from 'react';
import Autosuggest from 'react-autosuggest';
import { translate } from 'react-i18next';
import i18n from '../../services/i18n.js';
import { fullSearch } from '../../services/fullsearch';
import debounce from './debounce';


const styles = theme => ({
    // search box specific
    autosuggestContainer: {
        flexGrow: 1,
        position: 'relative',
        width: '100%',
        zIndex: 1000,
        fontWeight: 300,
    },
    autosuggestWrapper: {
        position: 'relative',
        width: '30%',
        paddingTop: '40px',
        float: 'left',
        marginRight: '2%',
        font: 'normal normal 300 normal 12px / 12px Roboto, Helvetica, Arial, sans-serif',
        color: theme.palette.background.tabHeaderSelected
    },
    autosuggestWrapperIE: {
        position: 'relative',
        width: '30%',
        paddingTop: '50px',
        float: 'left',
        marginRight: '2%',
        font: 'normal normal 300 normal 12px / 12px Roboto, Helvetica, Arial, sans-serif',
        color: theme.palette.background.tabHeaderSelected
    },
    autosuggestLabel: {
        color: 'var(--primary-text-color)',
        position: 'absolute',
        top: 24,
        left: 0,
    },
    autosuggestLabelIE: {
        color: 'var(--primary-text-color)',
        position: 'absolute',
        top: 33,
        left: 0,
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 3,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    keyboardIcon: {
        color: theme.palette.icon.main,
    },
    coloredIcon: {
        color: theme.palette.icon.main + '!important',
        marginRight: '-24px'
    },
    coloredIconIE: {
        color: theme.palette.icon.main + '!important',
        marginTop: '-20px',
        paddingBottom: '5px'
    },
});

const MAX_RESULTS = process.env.REACT_APP_FTS_MAX_RESULTS;

class FullTextSearchField extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            suggestions: [],
            selectedSuggestion: {},
            value: this.props.value
        };

        if (props.componentRef) {
            props.componentRef(this);
        }
    }

    onChangeSearchBox = (event, { newValue }) => {
        this.setState({
            selectedSuggestion: null,
            value: newValue,
        });
        this.props.setSelectedSuggestion(null);
    };

    clear = () => {
        this.setState({
            suggestions: [],
            value: ''
        });
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.selectedSuggestion && nextProps.selectedSuggestion != null) {
            this.setState({
                value: nextProps.selectedSuggestion.formattedName,
                selectedSuggestion: nextProps.selectedSuggestion
            });
        }
    }

    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        this.setState({
            selectedSuggestion: suggestion,
        });
        this.props.setSelectedSuggestion(suggestion);
    };

    onSuggestionHighlighted = async ({ suggestion }) => {
        /**
         * VTV-285
         * Method disabled because this change the current state of input.
         */
        return;
        if (suggestion) {
            setTimeout(() => {
                this.setState({
                    selectedSuggestion: suggestion,
                });
                this.props.setSelectedSuggestion(suggestion);
            }, 500);
        }
    };

    onSuggestionsFetchRequested = debounce(({ value }) => {
        this.loadSuggestions(value);
    }, parseInt(process.env.REACT_APP_FTS_DEBOUNCE, 10));

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    loadSuggestions = async value => {
        let formattedSuggestions = await fullSearch(value, this.props.endpoint, this.props.originCode);
        /*if(this.props.callTransfer){
            // Llamar al de transfers
        } else{*/
        //formattedSuggestions = await fullSearch(value, this.props.endpoint, this.props.extraValue);
        //}
        this.setState({
            suggestions: (formattedSuggestions || []).slice(0, MAX_RESULTS),
        });
    };

    getSuggestionValue = (suggestion) => {
        return suggestion.formattedName;
    }

    renderSectionTitle = (section) => {
        return (
            <div style={{ height: '40px', backgroundColor: 'lightgrey' }}>
                {this.getTitleIcon(section.title)}
                <strong style={{ float: 'left', margin: '10px 0 0 5px', top: '50%', color: 'grey' }}>{i18n.t(section.title).toUpperCase()}</strong>
            </div>
        );
    }

    getTitleIcon = (sectionTitle) => {
        const title = sectionTitle.toLowerCase();
        if (title.indexOf('hotels') !== -1) {
            return <HotelIcon style={{ float: 'left', padding: '5px 2px 0px 4px', color: '#757575' }} />;
        }

        if (title.indexOf('citi') !== -1) {
            return <CityIcon style={{ float: 'left', padding: '5px 2px 0px 2px', color: '#757575' }} />;
        }

        return <LocationIcon style={{ float: 'left', padding: '5px 2px 0px 2px', color: '#757575' }} />;
    }

    getSectionSuggestions = (section) => {
        return section.data;
    }

    shouldRenderSuggestions = (value) => {
        const MINIMUM_CHARS_TO_AUTOCOMPLETE = 3;
        return value.trim().length > MINIMUM_CHARS_TO_AUTOCOMPLETE;
    }

    renderInput = (inputProps) => {
        const { classes, ref, autofocus, isDisabled, ...other } = inputProps;

        return (
            <TextField
                fullWidth
                inputRef={ref}
                required={true}
                label={inputProps.placeholder}
                className="cmsFormContainer"
                autoFocus={autofocus}
                disabled={isDisabled}
                InputProps={{
                    classes: {
                        input: classes.input,
                    },
                    ...other,
                }}
            />
        );
    }

    renderSuggestion = (suggestion, { query, isHighlighted }) => {
        const titleCased = suggestion.formattedName;// S(suggestion.formattedName.toLowerCase()).titleCase().s;
        const repeatedquery = query + ' ' + query + ' ' + query;
        const matches = match(titleCased, repeatedquery);
        const parts = parse(titleCased, matches);
        // const type = suggestion.type;
        return (
            <MenuItem selected={isHighlighted} component="div">
                <div>
                    {parts.map((part, index) => {
                        return part.highlight ? (
                            <span key={String(index)} style={{ fontWeight: 600, color: '#444444' }}>
                                {part.text}
                            </span>
                        ) : (
                                <span key={String(index)} style={{ fontWeight: 300, color: '#757575' }}>
                                    {part.text}
                                </span>
                            );
                    })}
                </div>
            </MenuItem>
        );
    }

    renderSuggestionsContainer = (options) => {
        const { containerProps, children } = options;
        return (
            <Paper {...containerProps} square>
                {children}
            </Paper>
        );
    }

    render() {

        const { inputError, classes, width, t, autofocus, placeHolder, isDisabled } = this.props;
        const { suggestions, selectedSuggestion } = this.state;

        const theme = {
            container: classes.autosuggestContainer,
            suggestionsContainerOpen: classes.suggestionsContainerOpen,
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
        };
        let placeHolderText = placeHolder ? t(placeHolder) : t('COMMON.DESTINATION_AREA_HOTEL_NAME');
        const inputProps = {
            classes,
            value: this.state.value || '',
            placeholder: placeHolderText,
            onChange: this.onChangeSearchBox,
            selectedsuggestion: selectedSuggestion,
            label: placeHolderText,
            error: inputError,
            endAdornment: <LocationIcon className={classes.keyboardIcon} />,
            autofocus: autofocus !== undefined ? autofocus : true
        };

        return (
            <Autosuggest
                theme={theme}
                multiSection={true}
                suggestions={suggestions}
                renderInputComponent={this.renderInput}
                shouldRenderSuggestions={this.shouldRenderSuggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionSelected={this.onSuggestionSelected}
                onSuggestionHighlighted={this.onSuggestionHighlighted}
                renderSuggestionsContainer={this.renderSuggestionsContainer}
                getSuggestionValue={this.getSuggestionValue}
                renderSectionTitle={this.renderSectionTitle}
                getSectionSuggestions={this.getSectionSuggestions}
                renderSuggestion={this.renderSuggestion}
                inputProps={{ ...inputProps, isDisabled }}
            />);
    }
}

export default translate('translations')(withStyles(styles)(FullTextSearchField));


// WEBPACK FOOTER //
// ./src/components/SearchContent/FullTextSearchField.js